export const redirectUrl = "https://aistudio-typescript.vercel.app/";
